/**
 * Mobile (below `lg`) page hero: breadcrumb, `h1` title and the two paragraphs, with no image.
 * Live user: the Ryerson Gives Back page's hero,
 * `../../RyersonGivesBackPage/RyersonGivesBackHeader/RyersonGivesBackHeader.tsx`; also rendered
 * by `./EnvironmentHealthSafetyHeader.tsx`, which has no importer. The desktop counterpart is
 * `./EnvironmentHealthSafetyHeaderDesktop.tsx`.
 */
import { Breadcrumb } from "@ryerson/frontend.navigation";
import { ContentSection } from "@ryerson/frontend.layout";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import styled from "@emotion/styled";
import React from "react";
import { EnvironmentHealthSafetyProps } from "./EnvironmentHealthSafetyHeader";

const BreadcrumbContainer = styled.div`
	margin-top: 32px;
`;

/**
 * Renders the hero below `lg`. `imageUrl` is ignored; the wrapper id follows the same title-slug
 * rule as the desktop layout. `background` defaults to `"tertiary"`.
 */
const EnvironmentHealthSafetyHeaderMobile: React.FC<EnvironmentHealthSafetyProps> = ({
	...props
}) => {
	const { theme } = useTheme();
	const background = props?.background || "tertiary";

	return (
		<div id={props.title.toLocaleLowerCase().replace(/\s+/g, "-")}>
			<ContentSection type={background}>
				<BreadcrumbContainer theme={theme}>
					<Breadcrumb type="tertiary" size="xs" />
				</BreadcrumbContainer>
				<Typography variant="h1" type={background}>
					{props?.title}
				</Typography>
				<Typography type={background}>{props?.paragraph1}</Typography>
				<Typography type={background} size="md" variant="p">
					{props?.paragraph2}
				</Typography>
			</ContentSection>
		</div>
	);
};

export default EnvironmentHealthSafetyHeaderMobile;
